<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
  <mat-toolbar class="example-toolbar bg-white">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <div class="brand-icon">
      <img
        src="/assets/images/klusup.png"
        alt="Klusup"
        width="100"
        class="img-responsive pt-2"
      />
      <!-- <p class="settings-menu">{{ currentParentNav ? currentParentNav : parentNav.name }} - {{ currentSubNav ? currentSubNav : currentNavName }}</p> -->
    </div>
  </mat-toolbar>

  <mat-sidenav-container
    class="example-sidenav-container"
    [style.marginTop.px]="mobileQuery.matches ? 56 : 10"
  >
    <mat-sidenav
      #snav
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      [opened]="isSidenavOpen"
      class="bg-white"
    >
      <ul class="mcd-menu">
        @for (nav of fillerNav; track nav) {
          <li>
            @if (!nav.submenu) {
              <a
                [routerLink]="['/klusup', nav.name]"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <img
                  [src]="'../../../assets/' + nav.icon"
                  alt="{{ nav.name }} icon"
                  class="nav-icon"
                />
                <strong>{{ nav.name }}</strong>
              </a>
            }
            @if (nav.submenu) {
              <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel class="bg-white">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <img
                        [src]="'../../../assets/' + nav.icon"
                        alt="{{ nav.name }} icon"
                        class="nav-icon"
                      />
                      {{ nav.name }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @for (subnav of nav.submenu; track subnav) {
                    <mat-panel-description>
                      <a
                        [routerLink]="'/klusup/' + subnav.path"
                        routerLinkActive="active-link"
                        [routerLinkActiveOptions]="{ exact: true }"
                        matTooltip="{{ subnav.name }}"
                        [matTooltipPosition]="'right'"
                      >
                        <!-- <img [src]="'../../../assets/' + subnav.icon" alt="{{subnav.name}} icon" class="nav-icon"> -->
                        {{ subnav.name }}</a
                      >
                    </mat-panel-description>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            }
          </li>
        }
      </ul>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
